import type { ConversationListItemResponse } from "@redotech/effect-api-shared/models/shopper-ai/conversation/conversation";
import { EnhancedDataTable } from "@redotech/redo-web/components/ui/enhanced-data-table";
import { memo, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useConversationsTableContext } from "../conversations-table-context";

export const ConversationsTable = memo(function ConversationsTable({
  maxHeight = "calc(100vh - 200px)",
}: {
  maxHeight?: string;
}) {
  const navigate = useNavigate();
  const { teamId } = useParams<{ teamId: string }>();

  const {
    data,
    columns,
    hasNextPage,
    isFetchingNextPage,
    fetchNextPage,
    isLoading,
  } = useConversationsTableContext();

  const handleRowClick = useCallback(
    ({ row }: { row: ConversationListItemResponse }) => {
      if (teamId) {
        navigate(`/stores/${teamId}/support-v2/${row.id}`);
      }
    },
    [navigate, teamId],
  );

  const getRowId = useCallback(
    (row: ConversationListItemResponse) => row.id,
    [],
  );

  return (
    <EnhancedDataTable<ConversationListItemResponse>
      columns={columns}
      data={data}
      enableInfiniteScroll
      getRowId={getRowId}
      hasMore={hasNextPage}
      loading={isLoading}
      loadingMore={isFetchingNextPage}
      maxHeight={maxHeight}
      onLoadMore={fetchNextPage}
      onRowClick={handleRowClick}
    />
  );
});
